import { h } from 'preact';
import FormStructure from '../../client_forms/solepower/form_structure.js';
import { store } from '../../state/formState';
import FormField from '../form/form_field';

const Step3 = ({ update, errors = {} }) => {
  // Indices 0-8 are contact info, 14 is the "Reference" field
  const rowIndices = [4, 5, 6, 7, 8, 3, 2, 1, 0, 14];
  
  const fields = rowIndices.flatMap(i => 
    FormStructure.layout.rows[i] ? FormStructure.layout.rows[i].fields : []
  );

  // Notes field is located at row index 15
  const notesField = FormStructure.layout.rows[15]?.fields[0];

  return (
    <div className="step-inner">
      <h2>Drop your details below so we can reach you!</h2>
      
      {/* 1. Render contact fields + Reference */}
      {fields.map(field => {
        const adjustedConfig = { 
          ...field,
          type: field.mapping === 'Reference' ? 'select' : field.type,
          options: field.options || FormStructure.fields[field.mapping]?.options || []
        };

        return (
          <FormField 
            key={field.mapping}
            config={adjustedConfig} 
            value={store.formData[field.mapping] || ''}
            error={errors[field.mapping]} 
            autoComplete="on"
            onInput={(val) => {
              store.formData[field.mapping] = val;
              update(); 
            }}
          />
        );
      })}

      {/* 2. Final Notes field (Removed from Step 2, safely isolated here) */}
      {notesField && (
        <div style={{ marginTop: '20px' }}>
          <FormField 
            key={notesField.mapping}
            config={notesField} 
            value={store.formData.Notes || ''}
            error={errors.Notes} 
            onInput={(val) => {
              store.formData.Notes = val;
              update(); 
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Step3;